import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const ENTRIES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca'
        })
    })
})()
